import styled from "styled-components";

import { LogoIcon } from "assets";

export const JointAcademyAvatar: React.FC = () => {
  return (
    <Container>
      <LogoIcon title="Joint Academy" />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  background-color: ${({ theme }) => theme.colors.redesign.b10};
  border-radius: 50%;

  & > svg {
    height: 20px;
  }
`;
